<template>
  <div style="position: relative; width: 130px; display: inline-block;">
    <v-text-field
      v-model="count"
      label="Кол-во"
      hide-details="auto"
      filled
      dense
      :background-color="isInteger(count) ? (count > 0 ? '#99EE6B' : '') : '#f0dde0'"
      :hint="(product && product.unitName != product.productUnitName) ? (product.productUnitSize * count).toFixed(2) + ' ' + product.unitName : ''"
      :persistent-hint="product && product.unitName != product.productUnitName"
    >
    </v-text-field>
    <v-btn
      style="position: absolute; top: 20px; right: 0px;"
      icon
      @click="plus()"
    ><v-icon>mdi-plus-box-outline</v-icon></v-btn>
    <v-btn
      style="position: absolute; top: 20px; right: 30px;"
      icon
      @click="minus()"
    ><v-icon>mdi-minus-box-outline</v-icon></v-btn>
  </div>
</template>

<script>
export default {
  name: 'material-value',

  props: {
    value: [Number, String],
    product: Object
  },

  data() {
    return {
      count: this.value
    }
  },

  methods: {
    plus() {
      if (this.isInteger(this.count)) this.count++;
    },
    minus() {
      if (this.isInteger(this.count) && this.count >= 1) this.count--;
    }
  },

  watch: {
    count(newVal) {
      this.$emit('input', newVal);
    },
    value(newVal) {
      if (this.count != newVal) this.count = newVal;
    }
  }
}
</script>